<template>
  <div>
    <div v-if="data">
      <Top />
      <div class="container">
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <Pagination :numberOfDots="5" :numberOfVisitedDots="1" />
            <div class="clearfix"></div>
            <div class="header-wrapper">
              <h2 class="text-primary-fh" v-html="data.screening.medicineHeader"></h2>
            </div>
            <div class="clearfix"></div>
            <p v-html="data.screening.medicineText"></p>
            <div class="clearfix"></div>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <!-- MedicineList -->
            <div class="card" v-for="(key, name, i) in data.misc.medicinelist" v-bind:key="name">
              <h5 class="text-light" data-toggle="collapse" :data-target="'#card-' + key" >{{ name }}</h5>
              <div class="collapse" v-bind:id="'card-' + key" :class="(druglist[i].dose ||
                (druglist[i].amountperday || druglist[i].injectionsperweek)) ? 'show': ''">
                <div class="input-group">
                  <!-- Alla läkemedel utan särskilda krav -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].dose"
                    :disabled="noMedicine"
                    v-if="druglist[i].name !== 'ezetrol' &&
                      druglist[i].name !== 'praluent' &&
                      druglist[i].name !== 'repatha'">
                    <option :value="0">Välj dos</option>
                    <option
                      v-for="dose in data.misc.doselist"
                      :value="dose"
                      v-bind:key="dose">
                      {{ dose }}
                    </option>
                  </select>
                  <!-- Ezetrol -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].dose"
                    :disabled="noMedicine"
                    v-if="druglist[i].name === 'ezetrol'">
                    <option :value="0">Välj dos</option>
                    <option :value="10">10</option>
                  </select>
                  <!-- Praluent -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].dose"
                    :disabled="noMedicine"
                    v-if="druglist[i].name === 'praluent'">
                    <option :value="0">Välj dos</option>
                    <option :value="75">75</option>
                    <option :value="150">150</option>
                  </select>
                  <!-- Repatha -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].dose"
                    :disabled="noMedicine"
                    v-if="druglist[i].name === 'repatha'">
                    <option :value="0">Välj dos</option>
                    <option :value="140">140</option>
                  </select>
                  <select
                    class="form-control form-control-lg measure-unit-form-control"
                    v-model="druglist[i].unit" disabled>
                    <!-- :disabled="noMedicine || (druglist[i].name === 'praluent' ||
                    druglist[i].name === 'repatha' || druglist[i].name === 'ezetrol')"> -->
                    <option :value="0">Välj mått</option>
                    <option
                      v-for="measure in data.misc.measurementlist"
                      :value="measure"
                      v-bind:key="measure">
                      {{ measure }}
                    </option>
                  </select>
                </div>
                <div class="clearfix"></div>
                <!-- Alla läkemedel utan särskilda krav -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].amountperday"
                    :disabled="noMedicine"
                    v-if="druglist[i].name !== 'praluent' && druglist[i].name !== 'repatha' && druglist[i].name !== 'ezetrol'">
                    <option :value="0">Antal tabletter per dag</option>
                    <option
                      v-for="apd in data.misc.amountperdaylist"
                      :value="apd"
                      v-bind:key="apd">
                      {{ apd }}
                    </option>
                  </select>
                  <!-- Ezetrol -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].amountperday"
                    :disabled="noMedicine"
                    v-if="druglist[i].name === 'ezetrol'">
                    <option :value="0">Antal tabletter per dag</option>
                    <option :value="1">1</option>
                  </select>
                  <!-- Praluent & Repatha -->
                  <select
                    class="form-control form-control-lg"
                    v-model="druglist[i].injectionsperweek"
                    :disabled="noMedicine"
                    v-if="druglist[i].name === 'praluent' || druglist[i].name === 'repatha'">
                    <option :value="0">Antal injektioner varannan vecka</option>
                    <option :value="1">1</option>
                  </select>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="btn-group-toggle">
              <label
                class="btn btn-outline-secondary btn-lg btn-block checkbox-btn"
                :class="noMedicine ? 'active previous-answer': false">
              <input type="checkbox"
                v-model="noMedicine"
                v-bind:value="true"
                autocomplete="off">
              Nej
              </label>
            </div>
            <div class="clearfix"></div>
            <button
              class="btn btn-primary btn-lg btn-block"
              :disabled="(!druglistIncomplete() && !noMedicine)"
              @click="verifyMedicines()">
            Nästa</button>
            <div class="clearfix"></div>
            <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
            <div class="clearfix"></div>
            <small class="pull-left">Tryck nästa för att gå vidare, annars kan du gå tillbaka.</small>
          </div>
          <div class="col-sm"></div>
        </div>
      </div>
      <Bottom />
    </div>
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FieldId from '../plugins/fieldId'
import { request } from '../plugins/datocms'

export default {
  name: 'screeningmedicine',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      druglist: [{
        name: 'atorvastatin',
        key: 'd1',
        dose: 0,
        unit: 'mg',
        amountperday: 0
      },
      {
        name: 'pravastatin',
        key: 'd2',
        dose: 0,
        unit: 'mg',
        amountperday: 0
      },
      {
        name: 'simvastatin',
        key: 'd3',
        dose: 0,
        unit: 'mg',
        amountperday: 0
      },
      {
        name: 'rosuvastatin',
        key: 'd4',
        dose: 0,
        unit: 'mg',
        amountperday: 0
      },
      {
        name: 'ezetrol',
        key: 'd5',
        dose: 0,
        unit: 'mg',
        amountperday: 0
      },
      {
        name: 'praluent',
        key: 'd6',
        dose: 0,
        unit: 'mg',
        injectionsperweek: 0
      },
      {
        name: 'repatha',
        key: 'd7',
        dose: 0,
        unit: 'mg',
        injectionsperweek: 0
      }],
      noMedicine: false
    }
  },
  methods: {
    druglistIncomplete () {
      let result = null
      for (let i = 0; i < this.druglist.length; i++) {
        const drug = this.druglist[i]
        if (drug.dose !== 0 && (drug.amountperday !== 0 && drug.injectionsperweek !== 0)) {
          result = true
          break
        } else {
          result = false
        }
      }
      return result
    },
    getPreviousAnswer () {
      let loader = this.$loading.show()
      axios._get(config.screeningAnswerUri).then(response => {
        const result = response.data.answers.find(answ => answ.fieldId === 1293111)
        if (result && result.length !== 0) {
          const parsedResult = JSON.parse(result.answer)
          if (parsedResult.answer === 'Nej') {
            this.noMedicine = true
          }
          this.druglist = (parsedResult.drugs !== undefined) ? parsedResult.drugs : this.druglist
        }
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Request went bad to screeninganswers: ' + error)
          loader.hide()
        }
      })
    },
    verifyMedicines (_answer) {
      let loader = this.$loading.show()
      var answer = null
      var fieldId = FieldId('screeningmedicine')
      if (this.noMedicine) {
        answer = {
          question: 'Har du en pågående behandling med kolesterolsänkande läkemedel?',
          answer: 'Nej',
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
      } else {
        answer = {
          question: 'Har du en pågående behandling med kolesterolsänkande läkemedel?',
          answer: 'Ja',
          drugs: this.druglist,
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
      }
      if (answer !== null) {
        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), fieldId).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.$router.push({
              name: 'screening',
              params: { fieldId: '10113375' } // consentjournals
            })
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  watch: {
    noMedicine (noMed) {
      if (noMed) {
        sessionStorage.setItem('druglist', JSON.stringify(this.druglist))
        this.druglist.forEach(d => {
          d.dose = 0
          d.unit = 0
          if (typeof d.amountperday !== 'undefined') {
            d.amountperday = 0
          }
          if (typeof d.injectionsperweek !== 'undefined') {
            d.injectionsperweek = 0
          }
        })
      } else {
        if (sessionStorage.getItem('druglist')) {
          this.druglist = JSON.parse(sessionStorage.getItem('druglist'))
        }
      }
    }
  },
  beforeMount () {
    this.getPreviousAnswer()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            medicineHeader
            medicineText
          }
          misc {
            medicinelist
            measurementlist
            doselist
            amountperdaylist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 110px;
  margin-bottom: 50px;
  min-height: 60vh;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button,
select {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}
::-webkit-input-placeholder {
  text-align: right;
}
.measure-unit-form-control {
  max-width: 125px;
  color: #6c7592;
  cursor: pointer;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.pull-left {
  float: left !important;
}
.dropdown-toggle:after {
  content: none;
}
select { text-align-last: right; }
option { direction: rtl; }
.card {
  border: 2px solid #069ccc;
  padding: 15px;
  margin-bottom: 10px;
  background: #59c5e8;
}
.card-body {
  display: none;
}
.expanded-h5 {
  color: #fff !important;
}
.card h5 {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreeningMedicine.vue